module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAPCAYAAAAPr1RWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAiUlEQVQ4ja3NQQ0CMRRF0QqoArTgAzBBQBImQMC4wAZbksOCTgKTadpfeNv2n5tSGTIu2KSBYY/T2kPG5L17NFDgZ7k/12DRwAL2FcDN+pqBCjxvl7DFIxpowBPy/DEUwKEL/jjoCoThQOA4BHcGamvDg4F+OBiIw52BcbgR+B2uBP4HLwLXCPwCPiGYq42iZ7gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom.png
// module id = MGEE
// module chunks = 1